"use client";

import {JSX, useEffect, useRef} from "react";
import { useTranslation } from "react-i18next";
import {exo2SemiBold, ralewayBold} from "@@/utils/fonts";
import useMediaQuery from "@@/hooks/useMediaQuery";
import Image, {StaticImageData} from "next/image";
import GreenPlayerLogo from "@@/public/img/greenplayer/greenplayer_logo.svg";
import GreenPlayerApp from "@@/public/img/greenplayer/greenplayer_app.webp";
import useAppearOnScroll from "@@/hooks/useAppearsOnScroll";

interface ProductImageProps {
    title: string;
    ProductLogo?: StaticImageData;
    ProductImage?: StaticImageData;
    subtitle?: string;
    items: StaticImageData[];
    className?: string;
    sectionId?: string;
}

export default function ProductImage({title, ProductLogo, ProductImage, subtitle, items, className, sectionId}: ProductImageProps): JSX.Element {
    const { t, } = useTranslation();
    const isMobile = useMediaQuery("(max-width: 1200px)");
    const titleAnim = useAppearOnScroll<HTMLDivElement>({
        from: "fromBottom",
        duration: 1000,
        delay: 0,
        offset: 0
    });

    const imageAnim = useAppearOnScroll<HTMLDivElement>({
        from: "fromBottom",
        duration: 1000,
        delay: 0,
        offset: 0
    });

    const contentAnim = useAppearOnScroll<HTMLDivElement>({
        from: "fromBottom",
        duration: 1000,
        delay: 300,
        offset: 0
    });

    return (
        <section id={sectionId} className={`px-11 w-100 d-flex justify-center h-fit`}>
            <div className={`d-flex flex-column justify-center align-items-center gap-5 w-100 ${className}`}>
                <h2 ref={titleAnim.ref} style={titleAnim.style} className={`center ${exo2SemiBold.className} color-blue ${titleAnim.className}`}>{title}</h2>
                {ProductLogo && ProductImage && (
                    <div ref={imageAnim.ref} style={imageAnim.style} className={`${imageAnim.className} w-100 d-flex flex-column gap-2 justify-center align-items-center`}>
                        <Image  src={ProductLogo} alt={`logo greenplayer`} className={`w-auto center`}/>
                        <Image src={ProductImage} alt={`greenplayer app`} className={`w-100 h-fit`}/>
                    </div>
                )}
                <div ref={contentAnim.ref} className={`d-flex flex-column gap-2 justify-center align-items-center w-100 overflow-hidden ${contentAnim.className}`} style={contentAnim.style}>
                    {subtitle && (
                        <h3 className={`center color-blue`}>{subtitle}</h3>
                    )}
                    <ul className={`list-none d-flex gap-2 justify-center align-items-center flex-column-mobile`}>
                        {items.map((item, index) => (
                            <li key={index}>
                                <Image src={item} className={`h-3`} alt={`greenplayer item ${index}`}/>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
